/**
 * Created by Administrator on 2019/5/26.
 */
var storage={
    set(key,value){
        localStorage.setItem(key,JSON.stringify(value));
    },
    get(key){
        return JSON.parse(localStorage.getItem(key));
    },
    remove(){
        localStorage.removeItem(key)
    }

}
export default storage;